import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MatchSubjectComponent } from './module/new-order/component/match-subject/match-subject.component';
import { orderReferenceIdGuard } from './module/new-order/guard/order-reference-id.guard';
import { draftOrderResolver } from './module/new-order/resolver/draft-order.resolver';
import { NotFoundPageComponent } from './page/not-found-page/not-found-page.component';
import { OrderSubmittedPageComponent } from './page/order-submitted-page/order-submitted-page.component';
import { accessControlGuard } from './shared/guard/access-control.guard';
import { authGuard } from './shared/guard/auth.guard';
import { unAuthGuard } from './shared/guard/unauth.guard';
import { AppPermission, OrderPermission } from './shared/interface/common.interface';

const routes: Routes = [
  { path: '', redirectTo: 'orders', pathMatch: 'full' },
  {
    path: 'app/orders',
    redirectTo: 'orders',
    pathMatch: 'full',
  },
  {
    path: 'company',
    loadChildren: () =>
      import('./page/company-setting-page/company-setting-page.module').then((m) => m.CompanySettingPageModule),
    canActivate: [authGuard, accessControlGuard],
    data: { permissions: [AppPermission.COMPANY_EDIT_SETTINGS] },
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./page/user-setting-page/user-setting-page.module').then((m) => m.UserSettingPageModule),
    canActivate: [authGuard],
  },
  {
    path: 'orders/new',
    loadChildren: () => import('./page/new-order-page/new-order-page.module').then((m) => m.NewOrderPageModule),
    canActivate: [authGuard, accessControlGuard],
    data: { permissions: [AppPermission.ORDER_CREATE] },
  },
  {
    path: 'orders/ref/:referenceId',
    children: [],
    canActivate: [authGuard, orderReferenceIdGuard],
  },
  {
    path: 'orders/:orderId/view',
    loadChildren: () => import('./page/view-order-page/view-order-page.module').then((m) => m.ViewOrderPageModule),
    canActivate: [authGuard, accessControlGuard],
    data: { permissions: [OrderPermission.ORDER_VIEW] },
  },
  {
    path: 'orders/ref/:referenceId/view',
    loadChildren: () => import('./page/view-order-page/view-order-page.module').then((m) => m.ViewOrderPageModule),
    canActivate: [authGuard, orderReferenceIdGuard, accessControlGuard],
    data: { permissions: [OrderPermission.ORDER_VIEW] },
  },
  {
    path: 'orders/:orderId/match-subject',
    component: MatchSubjectComponent,
    resolve: { draftOrderResolver },
    canActivate: [authGuard],
  },
  {
    path: 'orders/:orderId',
    loadChildren: () => import('./page/order-page/order-page.module').then((m) => m.OrderPageModule),
    canActivate: [authGuard, accessControlGuard],
    data: { permissions: [OrderPermission.ORDER_EDIT, OrderPermission.ORDER_VIEW] },
  },
  {
    path: 'orders',
    loadChildren: () => import('./page/order-list-page/order-list-page.module').then((m) => m.OrderListPageModule),
    canActivate: [authGuard, accessControlGuard],
    data: { permissions: [AppPermission.ORDER_LIST] },
  },
  {
    path: 'property',
    loadChildren: () => import('./page/property-page/property-page.module').then((m) => m.PropertyPageModule),
    canActivate: [authGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./page/login-page/login-page.module').then((m) => m.LoginPageModule),
    canActivate: [unAuthGuard],
  },
  {
    path: 'order-submitted/:orderId',
    component: OrderSubmittedPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'not-found',
    component: NotFoundPageComponent,
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
